// = Libs =
import React from 'react';

// = Styles =
import classes from './container.module.scss';

const Container: React.FC = ({ children }) => {
  return <div className={classes.container}>{children}</div>;
};

export default Container;
